import { NFamilySchoolTheme as NFamilySchoolMFTheme } from '@famly/mf_theme';
import { hexToRGBA } from 'web-app/util/hex-to-rgb';
import BaseTheme from './base';
const NFamilySchoolChromeColor = '#0B1A3B';
const NFamilySchoolPrimary = NFamilySchoolChromeColor;
const NFamilySchoolActive = hexToRGBA(NFamilySchoolChromeColor, 0.8);
const NFamilySchoolBackgroundHover = hexToRGBA(NFamilySchoolChromeColor, 0.04);
const NFamilySchoolTheme = {
    ...BaseTheme,
    title: 'N Family School',
    chromeColor: NFamilySchoolChromeColor,
    primary: NFamilySchoolPrimary,
    active: NFamilySchoolActive,
    backgroundHover: NFamilySchoolBackgroundHover,
    mf: NFamilySchoolMFTheme,
};
export default NFamilySchoolTheme;
